import React from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import Servicios from './components/Servicios';
import Nosotros from './components/Nosotros';
import Trabajos from './components/Trabajos';
import Contacto from './components/Contacto';
import Footer from './components/Footer';
import './App.css';

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
function App() {
  return (
    <>
      <Header />
      <Hero />
      <Servicios />
      <Nosotros />
      <Trabajos /> 
      <Contacto />
      <Footer />

       {/* Botón de WhatsApp flotante */}
      <a
        href="https://wa.me/50375379826?text=Hola%2C%20estoy%20interesado%20en%20sus%20servicios."
        className="whatsapp-float"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img
          src="https://img.icons8.com/ios-filled/50/ffffff/whatsapp.png"
          alt="WhatsApp"
        />
      </a>
    </>
  );
}

export default App;
